import './CustomButton.scss'
import { Button } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import DownloadIcon from '@mui/icons-material/Download';
import { useNavigate } from 'react-router-dom'

interface ICustomButtom {
  to: string
  icon: 'go' | 'download' | 'none'
  children: React.ReactNode
  customAction?: () => void
}

export const CustomButton = ({
  to,
  icon,
  children,
  customAction,
  customClass,
}: ICustomButtom & { customClass?: string }) => {
  const navigate = useNavigate()
  const getIcon = () => {
    switch (icon) {
      case 'go':
        return <AddIcon />

      case 'download':
        return <DownloadIcon />

      case 'none':
        return null
    }
  }

  const handleClick = () => {
    if (customAction) {
      customAction()
      return
    }

    if (to.startsWith('http://') || to.startsWith('https://')) {
      // Es un enlace externo
      window.open(to, '_blank')
    } else {
      // Es una ruta interna
      navigate(to, { replace: true })
    }
  }

  return (
    <>
      <Button
        className={`custom-button ${customClass}`}
        startIcon={getIcon()}
        onClick={handleClick}
      >
        {children}
      </Button>
    </>
  )
}
